import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import ContributorStore from '../../stores/ContributorStore';
import HeaderBanner from '../../components/common/HeaderBanner';
import ContributorSection from '../../components/contributor/ContributorSection';
import MetaTags from '../../components/common/MetaTags';
@connectToStores
export default class ContributorView extends React.Component {
    static propTypes = {
        contributorStore: PropTypes.object //eslint-disable-line
    };
    static getStores() {
        return [ContributorStore];
    }

    static getPropsFromStores() {
        return {
            contributorStore: ContributorStore.getState()
        };
    }

    render() {
        const pageData = this.props.contributorStore || null;
        const {_title, communityContributors = {}} = pageData;
        const {communityContributor = [], title, headerImage} = communityContributors;
        
        return (
            <div className="contributor-view">
                <MetaTags meta={{title: _title}} />
                <HeaderBanner title={title} image={headerImage} />
                <div className="container-fluid content-container">
                    <div className="row">
                        {communityContributor.length > 0 &&
                            communityContributor.map((group) => {
                                return <ContributorSection data={group} key={group.contributorType} />
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}
